import { connect } from 'react-redux'
import { ClanQuestsTutorialView } from 'containers/ClanLanding/components/ClanQuestsTutorial/ClanQuestsTutorialView'

export const stateToProps = state => {
    return {
        language: state.locale.language,
        videoId: state.clanQuests.tutorial_video_id,
        isCNRealm: state.settings.isCNRealm,
    }
}

export default connect(stateToProps)(ClanQuestsTutorialView)



// WEBPACK FOOTER //
// ./containers/ClanLanding/components/ClanQuestsTutorial/ClanQuestsTutorialConnector.js